import { noop } from "../../../common/function";
import { legacyCookie, removeCookie, writeCookie } from "./cookie.js";
import { logLevels } from "./level.js";
import {
  type DebugConfig,
  type LogLevelInput,
  status,
  type StatusText,
  updateStatus,
} from "./status.js";
import { writeLog, type Writer } from "./writer.js";
import { loggerDataKey, logExtFunctions } from "./extensions.js";
import type { Debug, Logger, Scope, ScopeName } from "../index.js";

/**
 *
 *
 *
 *
 *
 */
export function scope<NS extends string = ScopeName>(scopeName: NS): Scope<NS> {
  return {
    scopeName,
    namespace: scopeName,
    /*                                                               */
    scope: (segment) => logger(`${scopeName}.${segment}`),
    isEnabled: ({ enabled, pattern } = status()) => enabled && !!pattern?.test(scopeName),
  };
}

/*                                   */
let write: Writer = noop;

/**
 *
 *
 *
 */
export const logExtensions = logExtFunctions.map((consoleMethod) => {
  return [
    consoleMethod,
    function (this: Logger, ...data: Parameters<Console[typeof consoleMethod]>): void {
      write(...this[loggerDataKey], data, consoleMethod);
    },
  ] as const;
}) as { [P in (typeof logExtFunctions)[number] as number]: [P, Console[P]] }[number][];

/**
 *
 *
 *
 *
 *
 */
export function logger<NS extends string = ScopeName>(scopeName: NS): Debug<NS> {
  const res = scope(scopeName) as Debug<NS>;
  res.log = (level, ...data) => write(level, scopeName, data);
  res.scope = (segment) => logger(`${scopeName}.${segment}`);

  res.table = (level, ...data) => write(level, scopeName, data, "table");

  logLevels.forEach((l) => {
    const logFunc = ((...data) => write(l, scopeName, data)) as Logger;
    logFunc[loggerDataKey] = [l, scopeName];
    logExtensions.forEach((wrapper) => {
      logFunc[wrapper[0]] = wrapper[1];
    });
    res[l] = logFunc;
  });

  return res;
}

/**
 *
 *
 *
 *
 */
export function updateWriter(state: DebugConfig): DebugConfig {
  write = state.enabled ? writeLog : noop;
  return state;
}

/**
 *
 *
 *
 *
 */
export function activate(
  namespace?: string | RegExp,
  level?: LogLevelInput,
  optins: { colors?: boolean } = {},
): DebugConfig {
  /*                                 */
  const config = updateStatus({ pattern: new RegExp(namespace || ".*"), level, ...optins });

  /*                                  */
  writeCookie(config);

  /*                                     */
  return updateWriter(config);
}

/**
 *
 *
 */
export function setColors(enabled: boolean): DebugConfig {
  /*                                 */
  const config = updateStatus({ colors: enabled });

  /*                                  */
  return writeCookie(config);
}

/**
 *
 *
 */
export function setLevel(level: LogLevelInput): DebugConfig {
  /*                                 */
  const config = updateStatus({ level });

  /*                                  */
  return writeCookie(config);
}

/**
 *
 */
export function activateLegacy(): StatusText {
  /*                  */
  legacyCookie();

  /*                       */
  return updateStatus({ activated: true }).text;
}

/**
 *
 *
 *
 */
export function deactivate(): DebugConfig {
  /*            */
  removeCookie();

  /*                       */
  return updateWriter(updateStatus({ pattern: null, activated: false }));
}
